import { useDialogQueueStore } from '../../store/useDialogQueueStore';

export function DialogQueueRenderer() {
  const { currentDialog } = useDialogQueueStore();

  if (!currentDialog) {
    return null;
  }

  return <>{currentDialog.component}</>;
}
